module.exports = __webpack_public_path__ + "static/media/(V)_MG_5458_-_Pro-Natura_-_Cia_Termal_Beachewear_-_Moda_Feminina.7a13c7ce.jpg";